import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

export const fetchTemplates = async () => {
    const response = await fetch(`/api/technical/checklist-templates`);
    if (!response.ok) {
        throw new Error('Failed to fetch templates');
    }
    return response.json();
};

export const useTemplates = () => {
    return useQuery({
        queryKey: ['templates'],
        queryFn: fetchTemplates
    });
};

export const fetchTemplateById = async (templateId) => {
    if (!templateId) {
        return null;
    }

    const response = await fetch(`/api/technical/checklist-templates/${templateId}`);
    if (!response.ok) {
        throw new Error(`Failed to fetch template ${templateId}`);
    }

    return response.json();
}

export const useChecklistTemplate = (templateId, options = {}) => {
    return useQuery({
        queryKey: ['template', templateId],
        queryFn: () => fetchTemplateById(templateId),
        enabled: !!templateId && (options.enabled !== false),
        ...options
    });
};

export const createChecklistFromTemplate = async ({ templateId, data}) => {
    const response = await fetch(`/api/technical/checklist-templates/${templateId}/initialize`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error('Failed to create checklist from template');
    }

    return response.json();
};

export const useCreateChecklist = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createChecklistFromTemplate,
        onSuccess: () => {
            queryClient.invalidateQueries('checklists');
        }
    });
};